export type UserPrivilege = `${Entity}_${Permission}`;

export const privilege = (entity: Entity, perm: Permission): UserPrivilege =>
  `${entity}_${perm}`;

export enum Permission {
  READ = 'READ',
  EDIT = 'EDIT',
}

export enum Entity {
  FEATURE_PARAMETER = 'FEATURE_PARAMETER',
  BANK = 'BANK',
  ACTIVITY_MATRIX = 'ACTIVITY_MATRIX',
  ACTIVITY = 'ACTIVITY',
  ACTIVITY_MATRIX_RUN = 'ACTIVITY_MATRIX_RUN',
  RESIDUAL_VALUE = 'RESIDUAL_VALUE',
  FULL_SERVICE_LEASING = 'FULL_SERVICE_LEASING',
  PRODUCT_LINE = 'PRODUCT_LINE',
  OPTION_PRICE = 'OPTION_PRICE',
  PRODUCT_LINE_PARAMETER = 'PRODUCT_LINE_PARAMETER',
  PRODUCT = 'PRODUCT',
  PRICE = 'PRICE',
  CALENDAR_RULE = 'CALENDAR_RULE',
  LIST_OF_VALUE = 'LIST_OF_VALUE',
  INSURANCE = 'INSURANCE',
  INSURANCE_PRODUCT = 'INSURANCE_PRODUCT',
  LOGIC_PROCESS = 'LOGIC_PROCESS',
  FINANCE_PRODUCT = 'FINANCE_PRODUCT',
  FINANCE_PRODUCT_MAPPING = 'FINANCE_PRODUCT_MAPPING',
  FSL_FILE = 'FSL_FILE',
  FILE = 'FILE',
  BANK_CONTRACT = 'BANK_CONTRACT',
  DEALER_STOCK = 'DEALER_STOCK',
  DEALER = 'DEALER',
  DEALER_PARAMETER_ADJUSTMENT = 'DEALER_PARAMETER_ADJUSTMENT',
  DEALER_PARAMETER_CONTROL = 'DEALER_PARAMETER_CONTROL',
  DEAL = 'DEAL',
  OPPORTUNITY = 'OPPORTUNITY',
  USER = 'USER',
  ROLE_AND_PRIVILEGE = 'ROLE_AND_PRIVILEGE',
  USED_VALUE = 'USED_VALUE',
  USED_VALUE_MATRIX = 'USED_VALUE_MATRIX',
  VEHICLE = 'VEHICLE',
  VEHICLE_MAPPING = 'VEHICLE_MAPPING',
  CAMPAIGN = 'CAMPAIGN',
  PRODUCT_ACTIVATION = 'PRODUCT_ACTIVATION',
  ORGANIZATION = 'ORGANIZATION',
  MAPPING = 'MAPPING',
  EXTERNAL_API_USER_DATA = 'EXTERNAL_API_USER_DATA',
  TDPP_REPORT_DATA = 'TDPP_REPORT_DATA',
}

export type UserRole = {
  privilege: UserPrivilege;
  role: string;
  organizationId: string;
};

export type UserRoles = UserRole[];
